import { render, staticRenderFns } from "./PackingCard.vue?vue&type=template&id=7e193af1&scoped=true&"
import script from "./PackingCard.vue?vue&type=script&lang=js&"
export * from "./PackingCard.vue?vue&type=script&lang=js&"
import style0 from "./PackingCard.vue?vue&type=style&index=0&id=7e193af1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e193af1",
  null
  
)

export default component.exports